import React, { useRef, useState, useEffect } from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const OtpInput = ({ length = 6, value, onChange, className }) => {
    const inputRefs = useRef([]);
    const [otp, setOtp] = useState(new Array(length).fill(""));

    useEffect(() => {
        if (value === "") {
            setOtp(new Array(length).fill(""));
        } else {
            const arr = value.split("").slice(0, length);
            const paddedArr = [...arr, ...new Array(length - arr.length).fill("")];
            setOtp(paddedArr);
        }
    }, [value, length]);

    const focusInput = (index) => {
        inputRefs.current[index]?.focus();
    };

    const handleChange = (e, index) => {
        const val = e.target.value;
        if (isNaN(val)) return;

        const newOtp = [...otp];
        // Allow only the last entered character if someone types fast
        newOtp[index] = val.substring(val.length - 1);
        
        const otpString = newOtp.join("");
        setOtp(newOtp);
        onChange(otpString);

        if (val && index < length - 1) {
            focusInput(index + 1);
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            // Move focus to previous input on backspace if current is empty
            focusInput(index - 1);
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text/plain").slice(0, length).trim();
        if (isNaN(pastedData)) return;

        const newOtp = [...otp];
        for (let i = 0; i < pastedData.length; i++) {
            newOtp[i] = pastedData[i];
        }
        setOtp(newOtp);
        onChange(newOtp.join(""));
        
        // Focus on the next empty input or the last input
        const nextIndex = Math.min(pastedData.length, length - 1);
        focusInput(nextIndex);
    };

    return (
        <div className={twMerge("flex justify-between items-center space-x-2", className)} onPaste={handlePaste}>
            {otp.map((data, index) => (
                <input
                    key={index}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    ref={(ref) => (inputRefs.current[index] = ref)}
                    value={data}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    className="w-12 h-14 text-center text-xl font-semibold border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-black transition-colors bg-white text-black"
                />
            ))}
        </div>
    );
};
